module.exports = __webpack_public_path__ + "static/media/seekerHiredFailed.a9691586.svg";